import React from "react";
import { Switch, Route, RouteComponentProps } from "react-router-dom";

import {
  LoginPage,
  NotFoundPage,
  SubscriptionUpgrade,
  SubscriptionSuccess,
  ReferralStatsPage,
  ChaptersManagement,
  ChapterCreation,
  ChapterEdit,
} from "./pages";
import DriversManagment from "./pages/DriversManagment";
import SignupPage from "./pages/SignupPage";
import QuestionsReponses from "./pages/QuestionsReponses";
import Parameters from "./pages/Parameters";
import FAQ from "./pages/FAQ";
import PrivateRoute from "./guards/PrivateRoute";
import Sidebar from "./components/Sidebar";
import TopBar from "./components/TopBar";
import { useTransporterRefresh } from "./hooks/useTransporterRefresh";

const MainLayout: React.FC<RouteComponentProps> = ({ match }) => {
  const { refreshTransporter } = useTransporterRefresh();

  React.useEffect(() => {
    refreshTransporter();
  }, [refreshTransporter]);

  return (
    <div className="flex">
      <Sidebar />
      <div className="flex-1 w-[calc(100vw-900px)]">
        <TopBar />
        <Switch>
          <PrivateRoute
            loginPage={false}
            exact
            path={`${match.path}drivers`}
            component={DriversManagment}
          />
          <PrivateRoute
            loginPage={false}
            exact
            path={`${match.path}chapters`}
            component={ChaptersManagement}
          />
          <PrivateRoute
            loginPage={false}
            exact
            path={`${match.path}chapters/create`}
            component={ChapterCreation}
          />
          <PrivateRoute
            loginPage={false}
            exact
            path={`${match.path}chapters/edit/:id`}
            component={ChapterEdit}
          />
          <PrivateRoute
            loginPage={false}
            exact
            path={`${match.path}questions`}
            component={QuestionsReponses}
          />
          <PrivateRoute
            loginPage={false}
            exact
            path={`${match.path}faq`}
            component={FAQ}
          />
          <PrivateRoute
            loginPage={false}
            exact
            path={`${match.path}parameters`}
            component={Parameters}
          />
          <PrivateRoute
            loginPage={false}
            exact
            path={`${match.path}referral-stats`}
            component={ReferralStatsPage}
          />
          <PrivateRoute
            loginPage={false}
            exact
            path={`${match.path}subscription`}
            component={SubscriptionUpgrade}
          />
          <PrivateRoute
            loginPage={false}
            exact
            path={`${match.path}subscription/success`}
            component={SubscriptionSuccess}
          />
          <PrivateRoute loginPage={false} component={NotFoundPage} />
        </Switch>
      </div>
    </div>
  );
};

function Router() {
  return (
    <>
      <Switch>
        <Route exact path="/signup" component={SignupPage} />
        <PrivateRoute loginPage={true} exact path="/" component={LoginPage} />
        <PrivateRoute loginPage={false} path="/" component={MainLayout} />
      </Switch>
    </>
  );
}

export default Router;
